import { render, staticRenderFns } from "./PartnerRedirectScreen.vue?vue&type=template&id=22957a55&scoped=true&"
import script from "./PartnerRedirectScreen.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PartnerRedirectScreen.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PartnerRedirectScreen.vue?vue&type=style&index=0&id=22957a55&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22957a55",
  null
  
)

export default component.exports